(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('QueueStopDialog',QueueStopDialog);

    QueueStopDialog.$inject = ['$uibModalInstance', 'entity', 'Queue'];

    function QueueStopDialog($uibModalInstance, entity, Queue) {
        var vm = this;
        vm.queue;

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.queue = entity;
            });
        }


        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmStop = function (id) {
            Queue.stopCron({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
